// extracted by mini-css-extract-plugin
module.exports = {"project":"project-module--project--28OWr","image":"project-module--image--2DNd_","info":"project-module--info--B_O9I"};